module.exports = __webpack_public_path__ + "static/images/i-gvip.9523d79.png";